Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DBlendFactor = module.exports.default = {
	DESTINATION_ALPHA: "destinationAlpha",
	DESTINATION_COLOR: "destinationColor",
	ONE: "one",
	ONE_MINUS_DESTINATION_ALPHA: "oneMinusDestinationAlpha",
	ONE_MINUS_DESTINATION_COLOR: "oneMinusDestinationColor",
	ONE_MINUS_SOURCE_ALPHA: "oneMinusSourceAlpha",
	ONE_MINUS_SOURCE_COLOR: "oneMinusSourceColor",
	SOURCE_ALPHA: "sourceAlpha",
	SOURCE_COLOR: "sourceColor",
	ZERO: "zero"
};